import { Loader } from 'google-maps';
const GeocodingServiceFactory = (GoogleMapApiKey) => {
    let autocompleteService;
    let geocoderService;
    let geocoderOk;
    const loadGoogleMap = async () => {
        if (!window.google) {
            const options = { libraries: ['places'] };
            const loader = new Loader(GoogleMapApiKey, options);
            const google = await loader.load();
            autocompleteService = new google.maps.places.AutocompleteService();
            geocoderService = new google.maps.Geocoder();
            geocoderOk = google.maps.GeocoderStatus.OK;
        }
        else if (!autocompleteService || !geocoderService || !geocoderOk) {
            autocompleteService = new window.google.maps.places.AutocompleteService();
            geocoderService = new window.google.maps.Geocoder();
            geocoderOk = window.google.maps.GeocoderStatus.OK;
        }
        return true;
    };
    const getLocationByCoords = async (lng, lat) => {
        await loadGoogleMap();
        return new Promise((resolve, reject) => {
            geocoderService.geocode({ location: { lat, lng } }, (results, status) => {
                if (status !== geocoderOk && results.length > 0) {
                    reject(status);
                }
                resolve({
                    placeId: results[0].place_id,
                    address: results[0].formatted_address,
                    alias: results[0].formatted_address,
                    latitude: results[0].geometry.location.lat(),
                    longitude: results[0].geometry.location.lng(),
                });
            });
        });
    };
    const getGeocodeByPlaceId = async (placeId) => {
        await loadGoogleMap();
        return new Promise((resolve, reject) => {
            geocoderService.geocode({ placeId }, (results, status) => {
                if (status !== geocoderOk || results == null) {
                    reject(status);
                }
                else {
                    resolve({
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),
                    });
                }
            });
        });
    };
    const getLocationByAddress = async (address) => {
        await loadGoogleMap();
        return new Promise((resolve) => {
            return autocompleteService.getPlacePredictions({
                input: address,
            }, (predictions) => {
                const res = predictions === null || predictions === void 0 ? void 0 : predictions.map((p) => ({
                    address: p.description,
                    alias: p.description,
                    placeId: p.place_id,
                }));
                resolve(res);
            });
        });
    };
    return {
        getLocationByCoords,
        getGeocodeByPlaceId,
        getLocationByAddress,
    };
};
export default GeocodingServiceFactory;
//# sourceMappingURL=geocoding.api.js.map